import { render } from "./modalFollowers.vue?vue&type=template&id=5d2bfd88"
import script from "./modalFollowers.vue?vue&type=script&lang=js"
export * from "./modalFollowers.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__